import {Component, Input, OnInit} from '@angular/core';
import {VocabularyModule} from '@app/models/content';

@Component({
  selector: 'app-vocabulary',
  templateUrl: './vocabulary.component.html',
  styleUrls: ['./vocabulary.component.scss']
})
export class VocabularyComponent implements OnInit {

  @Input() module: VocabularyModule;

  audios: HTMLAudioElement[];

  constructor() { }

  ngOnInit() {
    this.audios = this.module.vocabularies.map(voc => {
      return voc.audio ? new Audio(voc.audio) : null;
    });
  }

  playAudio(index: number) {
    if (this.audios[index]) {
      this.audios[index].play();
    }
  }

}
